// extracted by mini-css-extract-plugin
export var bounce = "_ou-1";
export var generatingText = "_ou-6";
export var lightning = "_ou-4";
export var popup = "_ou-5";
export var progressBar = "_ou-7";
export var progressFill = "_ou-8";
export var progressShimmer = "_ou-9";
export var progressText = "_ou-a";
export var shimmer = "_ou-3";
export var uploadIcon = "_ou-0";
export var uploadingText = "_ou-2";